import React from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import StatusBadge from "../../../../components/JewelleryPlans/common/StatusBadge";
import { PLAN_TYPES } from "../../../../constants/jewellery.constant";

const PlansTable = ({ plans, showRedemptionActions = false }) => {
  const navigate = useNavigate();

  const getPlanTypeLabel = (type) => {
    switch (type) {
      case PLAN_TYPES.VALUE_SAVINGS:
        return "Value";
      case PLAN_TYPES.WEIGHT_SAVINGS:
        return "Weight";
      case PLAN_TYPES.PRICE_LOCK:
        return "Price Lock";
      default:
        return type;
    }
  };

  return (
    <div className="bg-background shadow rounded-lg overflow-hidden">
      <table className="min-w-full divide-y divide-neutral-light">
        <thead className="bg-neutral-light">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-neutral-dark uppercase tracking-wider">
              Plan Number
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-neutral-dark uppercase tracking-wider">
              Customer
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-neutral-dark uppercase tracking-wider">
              Type
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-neutral-dark uppercase tracking-wider">
              Monthly
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-neutral-dark uppercase tracking-wider">
              Progress
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-neutral-dark uppercase tracking-wider">
              Maturity
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-neutral-dark uppercase tracking-wider">
              Status
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-neutral-dark uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-background divide-y divide-neutral-light">
          {plans.map((plan) => {
            const progress = plan.templateSnapshot?.tenureMonths
              ? ((plan.paymentsDone || 0) /
                  plan.templateSnapshot.tenureMonths) *
                100
              : 0;

            return (
              <tr
                key={plan._id}
                className="hover:bg-neutral-light cursor-pointer"
                onClick={() => navigate(`/jewellery/${plan._id}`)}
              >
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-text">
                    {plan.planNumber}
                  </div>
                  <div className="text-xs text-neutral-dark">
                    {format(new Date(plan.startDate), "dd MMM yyyy")}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-text">
                    {plan.userId?.name || "Customer"}
                  </div>
                  <div className="text-xs text-neutral-dark">
                    {plan.userId?.phoneNumber}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="text-sm text-text">
                    {getPlanTypeLabel(plan.templateSnapshot?.type)}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-text">
                    ₹{plan.monthlyAmount?.toLocaleString()}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div className="flex-1">
                      <div className="flex items-center">
                        <div className="w-20 bg-neutral-light rounded-full h-2 mr-2">
                          <div
                            className="bg-success h-2 rounded-full"
                            style={{ width: `${Math.min(progress, 100)}%` }}
                          />
                        </div>
                        <span className="text-xs text-neutral-dark">
                          {plan.paymentsDone || 0}/
                          {plan.templateSnapshot?.tenureMonths || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-text">
                    {plan.maturesOn
                      ? format(new Date(plan.maturesOn), "dd MMM yyyy")
                      : "-"}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <StatusBadge status={plan.status} />
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/jewellery/${plan._id}`);
                    }}
                    className="text-primary hover:text-primary-dark mr-3"
                  >
                    View
                  </button>
                  {showRedemptionActions && plan.status === "MATURED" && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/jewellery/${plan._id}/quote`);
                      }}
                      className="text-success hover:text-success-dark"
                    >
                      Redeem
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PlansTable;
